import renderItem from './item'
import bindAction from './bindAction'
import shuffleArray from '../utils/shuffleArray'
import initializeSlider from './initializeSlider'

const renderOffers = opts => {
  if(typeof opts.offers.showOffers !== 'undefined' && !opts.offers.showOffers)
    return

  if(window.innerWidth <= 480)
    return

  $.getJSON(opts.dataPaths.offers)
  .done((responze) => {
    let offers = responze.data

    // shuffle offers if selected in opts
    if(typeof opts.offers.showRandom !== 'undefined' && opts.offers.showRandom) {
      offers = shuffleArray(offers)
    }

    let list =  ''
    list += '<ul class="slides">'
      for (let i = 0; i < offers.length; i++) {
        list += renderItem(offers[i])
      }
    list += '</ul>'

    $(list).appendTo('#airticket-map-offers')

    $('#airticket-map-offers .item').each((index, item) => {
      $(item).on('click', e => bindAction(item))
    })

    initializeSlider()

    $(window).on('resize', function() {
      if(this.innerWidth <= 480) {
        // $('#airticket-map-offers ul').slick('slickPause')
      }
    })
  })
  .fail(() => {
    console.log('error');
  })
}

export default renderOffers



// WEBPACK FOOTER //
// ./app/offers/index.js